import { CanMatchFn } from '@angular/router';
import { environment } from '../../environment/environment';

/**
 * Matches `/associate`, project Discussion, and Inbox → Threads
 * when the client portal feature flag is on.
 */
export const clientPortalEnabledCanMatch: CanMatchFn = () =>
  environment.enableClientPortal === true;

/** Matches those routes when the flag is off so the app can redirect away. */
export const clientPortalDisabledCanMatch: CanMatchFn = () =>
  environment.enableClientPortal !== true;
